import React from 'react';
import _ from 'lodash';
import cn from 'classnames';
import { Radio, Input } from 'antd';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import SelectWithFilter from '../../SelectWithFilter';

import styles from './controls.less';

const RadioGroup = Radio.Group;

class Radiobutton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
    };
  }

  onChangeItem = (itemId) => {
    if (!this.props.editable) {
      return false;
    }

    this.setState({ value: itemId });
    this.props.onChange && this.props.onChange(itemId);
    this.props.onEndEditing && this.props.onEndEditing(itemId);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      const newValue = nextProps.value;
      this.setState({
        value: newValue,
      });
    }
  }

  render() {
    const { t, config, value, placeholder } = this.props;
    let items = config.get('items');
    const mode = config.get('mode');
    const type = config.get('type');

    const { editable } = this.props;
    let checkedItem;
    let content;

    // If not editable, filter items to show only the selected value
    if (!editable) {
      items = items.filter((item) => item.get('id') === value);
    }

    // Handle the rendering of a select or radio button field
    if (
      ((items && items.size) >= 7 && type !== 'radio' && type !== 'radiobuttonGroup') ||
      mode === 'dropdown' ||
      type === 'select' ||
      type === 'radiobuttonSelect'
    ) {
      if (!editable) {
        checkedItem = items.find((item) => item.get('id') === value);
        content = (
          <Input className={styles.radioSelectReadOnly} readOnly value={checkedItem && checkedItem.get('name')} />
        );
      } else {
        content = (
          <SelectWithFilter
            mode="single"
            value={{ key: this.state.value }}
            onChange={this.onChangeItem}
            placeholder={placeholder}
            notFoundContent={t('dropdown.noitems')}
            items={items.map((item) => ({ key: item.get('id'), text: item.get('name') })).toJS()}
            className={styles.radioSelect}
          />
        );
      }
    } else {
      const ComponentType = mode == 'buttons' ? Radio.Button : Radio;
      content = (
        <RadioGroup
          value={this.state.value}
          onChange={(e) => this.onChangeItem(e.target.value)}
          className={styles.radiogroupList}
        >
          {items.map((item, key) => {
            const ref = key ? 'input' : 'inputFirst';
            const id = String(item.get('id'));
            const Icon = item.get('icon');
            const IconComponent = Icon ? <Icon /> : null;

            return (
              <ComponentType
                key={id}
                className={cn({
                  [styles.radioItem]: mode !== 'buttons',
                  readonly: !editable,
                })}
                disabled={!editable}
                ref={ref} // need specify disabled to readonly
                checked={this.state.value === id}
                value={id}
              >
                {IconComponent}
                {item.get('name')}
              </ComponentType>
            );
          })}
        </RadioGroup>
      );
    }

    return content;
  }
}

Radiobutton.propTypes = {
  value: PropTypes.string,
  config: PropTypes.object,
  onChange: PropTypes.func,
  onEndEditing: PropTypes.func,
  editable: PropTypes.bool,
};

export default withTranslation()(Radiobutton);
